import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { menuCategories } from "../data/menu";
import CategoryIcon from "../illustrations/CategoryIcon";

// Category selector in the reference tab-strip pattern. Selection is URL
// driven (/menu/c/:slug) so Back/Forward and deep links work; arrow keys move
// and select like the dish switcher.
export default function CategoryStrip({ activeSlug }) {
  const navigate = useNavigate();
  const refs = useRef([]);
  const go = (i, focus) => {
    const c = menuCategories[i];
    navigate(`/menu/c/${c.slug}`, { state: { preserveScroll: true } });
    if (focus && refs.current[i]) refs.current[i].focus();
  };
  const onKeyDown = (e, i) => {
    let n = null;
    if (e.key === "ArrowRight") n = (i + 1) % menuCategories.length;
    else if (e.key === "ArrowLeft") n = (i - 1 + menuCategories.length) % menuCategories.length;
    else if (e.key === "Home") n = 0;
    else if (e.key === "End") n = menuCategories.length - 1;
    if (n === null) return;
    e.preventDefault();
    go(n, true);
  };
  return (
    <div className="ro-catstrip" role="tablist" aria-label="Menu categories">
      {menuCategories.map((c, i) => {
        const active = c.slug === activeSlug;
        return (
          <button
            key={c.slug}
            ref={(el) => (refs.current[i] = el)}
            type="button"
            role="tab"
            id={`ro-cat-tab-${c.slug}`}
            aria-selected={active}
            aria-controls="ro-fullmenu-panel"
            tabIndex={active ? 0 : -1}
            className={`ro-cat ${active ? "is-active" : ""}`}
            style={{ "--ro-theme": c.colour, "--ro-pale": c.pale }}
            onClick={() => go(i, false)}
            onKeyDown={(e) => onKeyDown(e, i)}
          >
            <span className="ro-cat__tile">
              <CategoryIcon name={c.icon} />
            </span>
            <span className="ro-cat__label">{c.short}</span>
          </button>
        );
      })}
    </div>
  );
}
